(function (global) {
    global.Vue          = require('_vue');
    global.VueRouter    = require('_vue-router');
    global.Vuex         = require('_vuex');
}(window));
